import React, { createContext, ReactNode, useContext } from 'react';

export const ShadowPortalContext = createContext<HTMLElement | null>(null);

export interface ShadowPortalProviderProps {
  children: ReactNode;
  value: HTMLElement | null;
}

export const ShadowPortalProvider = ({
  children,
  value,
}: ShadowPortalProviderProps) => {
  return (
    <ShadowPortalContext.Provider value={value}>
      {children}
    </ShadowPortalContext.Provider>
  );
};

export const usePortalContainer = (): HTMLElement | null => {
  const context = useContext(ShadowPortalContext);
  if (!context) {
    console.warn(
      'usePortalContainer must be used within a ShadowPortalProvider',
    );
  }
  return context;
};

export const usePortalProps = () => {
  const container = usePortalContainer();
  return function buildPortalProps<T extends Record<string, unknown>>(
    fallbackProps?: T,
  ): { container: HTMLElement } | ({ disablePortal: true } & T) {
    if (container) {
      return { container };
    }
    return { disablePortal: true, ...fallbackProps } as {
      disablePortal: true;
    } & T;
  };
};
